import React from 'react';
import ProductionPlanList from '../../../components/manufacturingmng/productionplan/ProductionPlanList';

/**
 * 생산 계획 탭 컨테이너
 * - 부모(ManufacturingDetailContainer)에서 전달받은 데이터 사용
 */
const ProductionPlanTabContainer = ({ productionPlan, planData, projectInfo, onRefresh }) => {
  return (
    <ProductionPlanList 
      productionPlan={productionPlan}
      planData={planData}
      projectInfo={projectInfo}
      onRefresh={onRefresh}
    />
  );
};

export default ProductionPlanTabContainer;
